// extracted by mini-css-extract-plugin
export default {"input-section":"Input_input-section__Lje1e","input-field":"Input_input-field__5REzA"};